import { Reducer } from "redux";

export interface SigningService {
  signingService?: boolean;
  signingServiceUrl?: string;
  encryptedSigningId?: string;
}

type SigningServiceType = SigningService | undefined;

export const defaults = {
  signingService: undefined,
  signingServiceUrl: undefined,
  encryptedSigningId: undefined,
};

export const reducer: Reducer<SigningServiceType> = (state: SigningServiceType = defaults): SigningServiceType => {
  return state;
};
